"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelProperties = {
    modelName: 'Icon',
    tableName: 'Icon',
    minAppVersion: '7.7.0',
    validations: {
        name: {
            type: 'length',
            min: 1,
            max: 25,
            bothOnlyMessagePromptId: 'ValidatorMessages.iconName',
            bothOnlyMessagePromptDefault: 'Name length must be between {min} and {max}',
        },
    },
    global: true,
};
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/icon/modelProperties.js.map